export default "__VITE_ASSET__DvpLsy2I__"